/**
 * Grab the user agent of the current user.
 *
 * @since 0.1.2
 *
 * @returns {string} The user agent as a string.
 */
export function userAgent() {
	return navigator.userAgent || '';
}

/**
 * Check if the user agent string has given needle.
 *
 * @since 0.1.39
 *
 * @param  {string} needle The needle to search for.
 *
 * @returns {boolean}       Whether the user agent string contains the given needle.
 */
export function userAgentHas(needle) {
	return userAgent().includes(needle);
}
